import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

let getTokenFn = null;
let getOrgIdFn = null;

export function setAuthTokenGetter(fn) {
  getTokenFn = fn;
}

export function setOrgIdGetter(fn) {
  getOrgIdFn = fn;
}

export const api = axios.create({
  baseURL: BACKEND_URL,
});

api.interceptors.request.use(async (config) => {
  if (getTokenFn) {
    try {
      const token = await getTokenFn();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (e) {
      console.warn('Failed to get auth token:', e);
    }
  }

  // Inject organization_id as query param if not already set
  if (getOrgIdFn) {
    const orgId = getOrgIdFn();
    if (orgId && !config.params?.organization_id) {
      config.params = { ...config.params, organization_id: orgId };
    }
  }

  return config;
});

// ── Response interceptor: feature gating 403 → friendly toast ──
let _lastFeatureToastAt = 0;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error?.response?.data?.detail;
    const code = typeof detail === 'object' ? detail?.code : null;
    if (error?.response?.status === 403 && code === 'feature_not_in_plan') {
      // Throttle to avoid toast spam on burst calls
      const now = Date.now();
      if (now - _lastFeatureToastAt > 1500) {
        _lastFeatureToastAt = now;
        const feature = detail?.feature || 'este módulo';
        toast.error(`Tu plan no incluye ${feature}`, {
          description: 'Actualiza tu plan para acceder a esta funcionalidad.',
          action: {
            label: 'Ver planes',
            onClick: () => { window.location.href = '/billing'; },
          },
        });
      }
    }
    return Promise.reject(error);
  }
);
